import { IconBed } from '@/app/common/icons/libraryIcons';
import React from 'react';
import Stars from '@/app/common/components/Stars';
import { convertImageUrlByWidthHeight } from '@/app/components/search/utils/images.ts';
import { isNil } from '@/app/components/search/Utilities.ts';
import {
  AutocompleteSuggestionCheck,
  AutocompleteSuggestionIcon,
  AutocompleteSuggestionLabel,
  SuggestionContent,
} from '@/app/common/filters/types/searchDynamic/styled.ts';

type CreateSuggestion = {
  id: string;
  value: string;
  iconImage: string;
  stars: number;
};

const ICON_SIZE_2X = 64;

export const createSuggestion = ({ id, value, iconImage, stars }: CreateSuggestion) => {
  const icon = iconImage === '' ? <IconBed size="16" /> : null;
  // Painted 32x32 as a background-image, so there is no srcset to pick a candidate: ask for the 2x
  // one outright, or it is soft on every retina screen.
  const optimisedIconImage = convertImageUrlByWidthHeight(iconImage, ICON_SIZE_2X, ICON_SIZE_2X);
  const showStars = !isNil(stars) && stars > 0;
  const starsContent = showStars ? <Stars stars={stars} black={true} /> : null;

  return {
    id,
    value,
    suggestionContent: (
      <SuggestionContent>
        <AutocompleteSuggestionIcon className="oss-ui-autocomplete-suggestion-icon" iconImage={optimisedIconImage}>
          {icon}
        </AutocompleteSuggestionIcon>
        <AutocompleteSuggestionLabel>{value}</AutocompleteSuggestionLabel>
        {showStars && (
          <AutocompleteSuggestionCheck className="oss-ui-autocomplete-suggestion-check">
            {starsContent}
          </AutocompleteSuggestionCheck>
        )}
      </SuggestionContent>
    ),
  };
};
